const STORAGE_KEY = "basket_items";

function load() {
	try {
		return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
	} catch {
		return [];
	}
}

export const namespaced = true;

export const state = {
	items: load(),
};

export const getters = {
	items: (state) => state.items,
	count: (state) => state.items.reduce((sum, i) => sum + (i.quantity || 1), 0),
};

export const mutations = {
	ADD_ITEM(state, batch) {
		const existing = state.items.find((i) => i._id === batch._id);
		if (existing) {
			existing.quantity = (existing.quantity || 1) + 1;
		} else {
			state.items.push({ ...batch, quantity: 1 });
		}
		localStorage.setItem(STORAGE_KEY, JSON.stringify(state.items));
	},
	INCREMENT_ITEM(state, id) {
		const existing = state.items.find((i) => i._id === id);
		if (existing) {
			existing.quantity = (existing.quantity || 1) + 1;
			localStorage.setItem(STORAGE_KEY, JSON.stringify(state.items));
		}
	},
	DECREMENT_ITEM(state, id) {
		const existing = state.items.find((i) => i._id === id);
		if (!existing) return;
		if (existing.quantity > 1) {
			existing.quantity -= 1;
		} else {
			state.items = state.items.filter((i) => i._id !== id);
		}
		localStorage.setItem(STORAGE_KEY, JSON.stringify(state.items));
	},
	REMOVE_ITEM(state, id) {
		state.items = state.items.filter((i) => i._id !== id);
		localStorage.setItem(STORAGE_KEY, JSON.stringify(state.items));
	},
	CLEAR(state) {
		state.items = [];
		localStorage.setItem(STORAGE_KEY, JSON.stringify(state.items));
	},
};
